/* eslint-disable react/destructuring-assignment */
import React from 'react';
import {
  Button,
  Modal,
  Form,
  Input,
  Upload,
  Select,
  message,
  Icon,
  Row,
  Col,
  Radio,
  Popover,
} from 'antd';
import { connect } from 'dva';
import classNames from 'classnames';
import { colorsArr, iconsArr } from '../../../../utils/modelData';
import styles from './setBlock.less';
import iconStyles from '../../icons.less';
import { url as api } from '../../../../services/service-utils';
import SelectArticle from './selectArticle';
import listImg from '../../../assets/micro-website/list.png';
import cardImg from '../../../assets/micro-website/card.png';
import cardList from '../../../assets/micro-website/cardList.jpg';
import { getAppCode } from '../../../../utils/utils';

const FormItem = Form.Item;
const { Option } = Select;

const colors = colorsArr;
const icons = iconsArr;

@Form.create()
@connect(({ homePage }) => ({
  ...homePage,
}))
class SelectBlock extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showSubType: false,
      // 栏目
      channelList: [],
      subChannelList: [],
      // 父子栏目对应
      channelMap: {},
      subChannelId: [],
      colorText: '',
      isFirst: false,
      channelId: '',
    };
  }

  componentDidMount() {
    const channelMap = {};
    const { dispatch } = this.props;

    dispatch({
      type: 'homePage/fetchChannelList',
      params: { appCode: getAppCode() },
    }).then(res => {
      (res || []).forEach(item => {
        channelMap[item.id] =
          item.subordinateChannels && item.subordinateChannels.length
            ? item.subordinateChannels
            : [];
      });
      this.setState({
        channelList: res,
        channelMap,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    const { isFirst } = this.state;
    const { visible } = nextProps;
    if (!isFirst && visible) {
      const { data } = nextProps;
      const { channelMap } = this.state;
      const dataTemp = JSON.parse(JSON.stringify(data));
      let channelId = dataTemp.columnurlorkey;
      // 设置二级栏目展示
      const subChannelId = [];

      if (dataTemp) {
        if (dataTemp.columnurlorkey) {
          // 当前已选父栏目对应的子栏目
          const subChannelList = channelMap[dataTemp.columnurlorkey];

          // channelId可能不存在 需要过滤
          if (!subChannelList) {
            channelId = '';
          }

          // 一级栏目channelId存在 需要加载二级栏目
          if (subChannelList && subChannelList.length) {
            subChannelList.forEach(item => {
              if ((dataTemp.showSubChannelid || '').indexOf(item.id) > -1) {
                // 当前已选子栏目
                subChannelId.push(`${item.id}`);
              }
            });
            this.setState({
              showSubType: true,
              subChannelId,
              subChannelList,
            });
          } else {
            this.setState({
              showSubType: false,
              subChannelId,
              subChannelList: [],
            });
          }
        } else {
          this.setState({
            showSubType: false,
            subChannelList: [],
            subChannelId: [],
          });
        }
      }
      this.setState({ isFirst: true, channelId });
    }
  }

  onConfirm = () => {
    const {
      // 当前编辑的对象
      data,
      activeModel,
      changeContent,
      form,
      selectedBlockIndex,
    } = this.props;

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      const {
        name,
        channelId,
        subChannelId = [],
        image,
        blockColor,
        icon,
        url = '',
        moduleType,
        showNewsType = 0,
        showIconType = 0,
      } = values;
      let params = {
        ...data,
        moduleName: name,
        columnurlorkey: channelId,
        showSubChannelid: subChannelId.join(','),
        url,
        moduleType,
        showNewsType,
        showIconType,
      };

      if (name && name.length > 8) {
        message.warning('版块名称最多允许8个字符');
        return;
      }
      if (
        activeModel === 2 ||
        (activeModel === 5 && showIconType === 1 && selectedBlockIndex < 6) ||
        (activeModel === 52 && selectedBlockIndex < 4) ||
        (activeModel === 51 && showIconType === 1 && selectedBlockIndex < 8) ||
        (activeModel === 6 && selectedBlockIndex === 4)
      ) {
        // 图片模板
        if (!image) {
          message.warning('请上传背景图片');
          return;
        }
        params = { ...params, fileId: image };
      } else if (activeModel === 3) {
        // 色块模板
        if (!blockColor) {
          message.warning('请选择填充颜色');
          return;
        }
        params = { ...params, fileId: blockColor };
      } else if (
        activeModel === 30 ||
        activeModel === 30 ||
        activeModel === 31 ||
        activeModel === 4 ||
        activeModel === 40 ||
        activeModel === 41 ||
        activeModel === 42 ||
        (activeModel === 5 && selectedBlockIndex < 6) ||
        (activeModel === 51 && selectedBlockIndex < 8) ||
        (activeModel === 6 && selectedBlockIndex < 4)
      ) {
        if (showIconType === 0) {
          // 图标模板
          if (!icon) {
            message.warning('请选择栏目图标');
            return;
          }
          if (!blockColor) {
            message.warning('请选择填充颜色');
            return;
          }
          params = { ...params, fileId: `${icon};${blockColor}` };
        }
        if (showIconType === 1) {
          if (!image) {
            message.warning('请上传栏目图标');
            return;
          }
          params = { ...params, fileId: image };
        }
      }

      this.setState({ loading: true });

      changeContent(params);
      setTimeout(() => {
        this.setState({ loading: false });
        this.closeModal();
        message.success('版块设置成功');
      }, 300);
    });
  };

  closeModal = () => {
    const { close, form } = this.props;
    const { resetFields } = form;
    close();
    resetFields();

    this.setState({
      showSubType: false,
      subChannelList: [],
      subChannelId: [],
      colorText: '',
      isFirst: false,
    });
  };

  // 栏目
  typeChange = value => {
    const { form, formData, selectedBlockIndex, dispatch } = this.props;
    const { modulesData } = formData;
    const { channelMap } = this.state;
    const subChannelList = channelMap[value] || [];
    const subChannelId = [];

    // 默认全选
    subChannelList.forEach(item => {
      subChannelId.push(`${item.id}`);
    });

    this.setState(
      {
        showSubType: subChannelList.length > 0,
        subChannelList,
        subChannelId,
      },
      () => {
        form.setFieldsValue({
          subChannelId,
        });
      }
    );

    const arr = JSON.parse(JSON.stringify(modulesData));
    const data = arr[selectedBlockIndex];
    if (data) {
      // 列表模板 一级栏目变化需清空文章
      if (value !== data.columnurlorkey) {
        data.showNewidsArr = [];
      }
      arr[selectedBlockIndex] = data;
      dispatch({
        type: 'homePage/saveState',
        payload: {
          formData: {
            ...formData,
            modulesData: arr,
            modules: arr,
          },
        },
      });
    }
  };

  // subTypeChange = value => {
  //   console.log('value', value);
  //   const { formData, selectedBlockIndex, dispatch } = this.props;
  //   const { modulesData } = formData;
  //   const arr = JSON.parse(JSON.stringify(modulesData));
  //   const data = arr[selectedBlockIndex];
  //   console.log('data', data);
  //   console.log('data.showNewidsArr', data.showNewidsArr);
  //   data.showNewidsArr = (data.showNewidsArr || []).filter(ele => {
  //     return value.indexOf(ele) !== -1;
  //   });
  //   dispatch({
  //     type: 'homePage/saveState',
  //     payload: {
  //       formData: {
  //         ...formData,
  //         modulesData: arr,
  //         modules: arr,
  //       },
  //     },
  //   });
  // };

  // 选中颜色
  changeColor = color => {
    const { form } = this.props;

    form.setFieldsValue({
      blockColor: color,
    });
    this.setState({
      colorText: color,
    });
  };

  // 选中图标
  changeIcon = icon => {
    const { form } = this.props;
    const { setFieldsValue, getFieldValue } = form;
    setFieldsValue({
      icon,
      iconColor: getFieldValue('iconColor'),
    });
  };

  // 清空已有设置
  resetForm = () => {
    const { form, resetBlock } = this.props;
    const { setFieldsValue } = form;
    setFieldsValue({
      name: '',
      channelId: '',
      blockColor: '',
      iconColor: '',
      icon: '',
      image: '',
      subChannelId: [],
      showNewsType: 0,
      showIconType: 0,
    });

    this.setState({
      showSubType: false,
      subChannelList: [],
      subChannelId: [],
      colorText: '',
    });
    resetBlock();
  };

  renderFormList = (activeModel, formItemLayout) => {
    const { selectedBlockIndex } = this.props;
    if (
      activeModel === 2 ||
      (activeModel === 6 && selectedBlockIndex === 4) ||
      (activeModel === 52 && selectedBlockIndex < 4)
    ) {
      return this.renderImageModel(formItemLayout, '背景图片', '326*168');
    }
    if (activeModel === 3) {
      return this.renderColorModel(formItemLayout);
    }
    if (
      activeModel === 30 ||
      activeModel === 31 ||
      activeModel === 4 ||
      activeModel === 40 ||
      activeModel === 41 ||
      activeModel === 42 ||
      (activeModel === 5 && selectedBlockIndex < 6) ||
      (activeModel === 51 && selectedBlockIndex < 8) ||
      (activeModel === 6 && selectedBlockIndex < 4)
    ) {
      return this.renderIconModel(formItemLayout);
    }

    return null;
  };

  renderImageModel = (formItemLayout, label, size) => {
    const { form, data = {} } = this.props;
    const { fileId = '' } = data;

    const { getFieldProps } = form;
    const uploadProps = {
      name: 'file',
      action: `${api.url}/web/v3/news/file/upload`,
      withCredentials: true,
      showUploadList: false,
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        const isJpgOrPng =
          file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isLt2M) {
          message.warning('图片大小不能超过2M');
        }
        if (!isJpgOrPng) {
          message.warning('只能上传 jpg/jpeg/ png 格式的图片');
        }
        return isJpgOrPng && isLt2M;
      },
      onChange(info) {
        const { status, response } = info.file;

        const setResult = type => {
          const isSuccess = type === 'success';

          if (isSuccess) {
            message.success('图片上传成功');
          } else {
            message.error('图片上传失败');
          }

          form.setFieldsValue({
            image: isSuccess ? response.data.fileUrl : '',
          });
        };

        if (status === 'done') {
          setResult('success');
        } else if (status === 'error') {
          setResult('error');
        }
      },
    };
    return (
      <FormItem {...formItemLayout} label={label}>
        <section
          className="upload-image"
          {...getFieldProps('image', {
            initialValue: fileId,
            rules: [
              {
                required: true,
                message: `请选择${label}`,
              },
            ],
          })}
        >
          <Upload.Dragger
            className={label === '图标' ? 'upload icon-upload' : 'upload'}
            {...uploadProps}
          >
            <div
              className="uploadView"
              style={{ backgroundImage: `url(${form.getFieldValue('image')})` }}
            />
            <Icon type="plus" />
          </Upload.Dragger>
        </section>
        <div className="p-info">
          说明：建议上传{size}像素的图片，仅支持jpg、jpeg和png格式，大小不超过2M。
        </div>
      </FormItem>
    );
  };

  renderColorModel = formItemLayout => {
    const { data = {} } = this.props;
    const { colorText } = this.state;
    const { fileId = '' } = data;
    let color = '';
    if (fileId && fileId.indexOf('#') > -1) {
      // 色块
      color = fileId;
    }
    return this.renderColorItem(formItemLayout, color, colorText);
  };

  renderIconModel = formItemLayout => {
    const { form, data = {} } = this.props;
    const { colorText } = this.state;
    const { fileId = '', showIconType } = data;
    const { getFieldProps } = form;
    let color = '';
    let icon = '';
    if (fileId && fileId.indexOf(';') > -1) {
      const fileIdArr = fileId.split(';');
      [icon, color] = fileIdArr;
    }

    return (
      <section>
        <Form.Item className="form-item-row" {...formItemLayout} label="内容设置">
          <Radio.Group
            {...getFieldProps('showIconType', {
              initialValue: showIconType,
              rules: [
                {
                  required: true,
                },
              ],
            })}
          >
            <Radio value={0}>系统图标</Radio>
            <Radio value={1}>自定义图标</Radio>
          </Radio.Group>
        </Form.Item>
        {form.getFieldValue('showIconType') === 0 && (
          <>
            <FormItem
              {...formItemLayout}
              wrapperCol={{ span: 19 }}
              label="栏目图标"
              style={{ marginBottom: 0 }}
            >
              <div
                className={styles['icon-container']}
                {...getFieldProps('icon', {
                  initialValue: icon,
                  rules: [
                    {
                      required: true,
                      message: '请选择栏目图标',
                    },
                  ],
                })}
              >
                {icons.map(item => (
                  <div
                    key={item}
                    onClick={() => this.changeIcon(item)}
                    className={`${styles['icon-block']} ${iconStyles[item]} ${iconStyles.icon} ${
                      form.getFieldValue('icon') === item ? iconStyles.active : ''
                    }`}
                  />
                ))}
              </div>
            </FormItem>
            {this.renderColorItem(formItemLayout, color, colorText)}
          </>
        )}
        {form.getFieldValue('showIconType') === 1 &&
          this.renderImageModel(formItemLayout, '图标', '640*640')}
      </section>
    );
  };

  renderColorItem = (formItemLayout, color, colorText) => {
    const { form } = this.props;
    const { getFieldProps } = form;
    return (
      <FormItem {...formItemLayout} wrapperCol={{ span: 18 }} label="填充颜色">
        <div
          className={styles['block-container']}
          {...getFieldProps('blockColor', {
            initialValue: color,
            rules: [
              {
                required: true,
                message: '请选择填充颜色',
              },
            ],
          })}
        >
          {colors.map(item => (
            <div key={item} className={styles.block} onClick={() => this.changeColor(item)}>
              <div
                style={{ background: item }}
                className={`${styles.checked} ${
                  form.getFieldValue('blockColor') === item ? styles.active : ''
                }`}
              >
                &nbsp;
              </div>
            </div>
          ))}
        </div>
        <span className={styles['block-hover']}>
          <span
            style={{
              background: form.getFieldValue('blockColor'),
            }}
            className={styles.block}
          >
            &nbsp;
          </span>
          <Input type="text" value={colorText} />
        </span>
      </FormItem>
    );
  };

  // 列表板块设置
  renderListItem = formItemLayout => {
    const { form, selectNews, callBack, data = {} } = this.props;
    const { showNewsType = 0, moduleType = 1 } = data;
    const { getFieldProps, getFieldValue } = form;
    const channelId = getFieldValue('channelId') || this.state.channelId || '';
    const subChannelId =
      getFieldValue('subChannelId') && getFieldValue('subChannelId').length > 0
        ? getFieldValue('subChannelId')
        : this.state.subChannelId || [];
    const content = (
      <div className={styles['demo-img']}>
        <div>
          <img src={listImg} alt="" />
          <span>列表式</span>
        </div>
        <div>
          <img src={cardImg} alt="" />
          <span>卡片式</span>
        </div>
        <div>
          <img src={cardList} alt="" />
          <span>卡片滚动</span>
        </div>
      </div>
    );
    return (
      <>
        <FormItem
          className="form-item-row form-item-list-style"
          {...formItemLayout}
          label="展示样式"
        >
          <Select
            {...getFieldProps('moduleType', {
              initialValue: moduleType,
              rules: [
                {
                  required: true,
                  message: '请选择展示样式',
                },
              ],
            })}
          >
            <Option key={4} value={4}>
              卡片式
            </Option>
            <Option key={6} value={6}>
              卡片滚动式
            </Option>
            <Option key={1} value={1}>
              列表式
            </Option>
          </Select>
        </FormItem>
        <Row className="form-item-row">
          <Col offset={4}>
            <Popover content={content} trigger="hover">
              <span style={{ fontSize: 14, color: '#1785EC', cursor: 'pointer' }}>示意图</span>
            </Popover>
          </Col>
        </Row>
        {this.renderColumn(formItemLayout)}
        <Form.Item className="form-item-row" {...formItemLayout} label="内容设置">
          <Radio.Group
            {...getFieldProps('showNewsType', {
              initialValue: showNewsType,
              rules: [
                {
                  required: true,
                },
              ],
            })}
          >
            <Radio value={0}>板块下最新4篇资讯</Radio>
            <Radio value={1}>自选文章</Radio>
          </Radio.Group>
        </Form.Item>
        {getFieldValue('showNewsType') === 1 && (
          <SelectArticle
            selectNews={selectNews}
            callBack={callBack}
            channelId={subChannelId.length > 0 ? subChannelId.join(',') : channelId || ''}
          />
        )}
      </>
    );
  };

  renderColumn = formItemLayout => {
    const { form } = this.props;

    const { channelList, subChannelList, showSubType, subChannelId, channelId } = this.state;

    const { getFieldProps } = form;

    const subTypeCls = classNames({
      hide: !showSubType,
    });
    return (
      <>
        <FormItem className="form-item-row" {...formItemLayout} label="对应栏目">
          <Select
            {...getFieldProps('channelId', {
              initialValue: channelId,
              rules: [
                {
                  required: true,
                  message: '请选择版块栏目',
                },
              ],
              onChange: this.typeChange,
            })}
          >
            {channelList.map(item => (
              <Option key={item.id} value={`${item.id}`}>
                {item.name}
              </Option>
            ))}
          </Select>
        </FormItem>
        <FormItem {...formItemLayout} label="下属栏目" className={subTypeCls}>
          <Select
            mode="multiple"
            {...getFieldProps('subChannelId', {
              initialValue: subChannelId,
              rules: [
                {
                  required: showSubType,
                  type: 'array',
                  message: '请选择版块下属栏目',
                },
              ],
              // onChange: this.subTypeChange,
            })}
          >
            {subChannelList.map(item => (
              <Option key={item.id} value={`${item.id}`}>
                {item.name}
              </Option>
            ))}
          </Select>
        </FormItem>
      </>
    );
  };

  renderFooter = () => {
    const { loading } = this.state;
    const { activeModel, deleteBlock, selectedBlockIndex } = this.props;
    const footer = [
      <Button key="1" type="ghost" onClick={this.resetForm}>
        清空并保存
      </Button>,
      <Button key="2" type="primary" loading={loading} onClick={this.onConfirm}>
        保存
      </Button>,
    ];

    if (
      activeModel === 1 ||
      activeModel === 10 ||
      (activeModel === 5 && selectedBlockIndex > 5) ||
      (activeModel === 51 && selectedBlockIndex > 7) ||
      (activeModel === 52 && selectedBlockIndex > 3) ||
      (activeModel === 6 && selectedBlockIndex > 4)
    ) {
      footer.unshift(
        <Button key="3" type="ghost" onClick={deleteBlock}>
          删除
        </Button>
      );
    }
    return footer;
  };

  render() {
    const { form, visible, data = {}, activeModel, selectedBlockIndex } = this.props;
    const { moduleName = '', url = '', moduleType = 1 } = data;

    const { getFieldProps, getFieldValue } = form;
    const formItemLayout = {
      labelCol: {
        span: 4,
      },
      wrapperCol: {
        span: 18,
      },
    };

    return (
      <div className={styles['set-block-body']}>
        <Modal
          title="版块设置"
          centered
          visible={visible}
          wrapClassName={styles.centerModal}
          className={styles.modal}
          onCancel={this.closeModal}
          footer={this.renderFooter()}
        >
          <Form className={styles['set-block-body-form']}>
            <FormItem className="form-item-row" {...formItemLayout} label="版块名称">
              <Input
                {...getFieldProps('name', {
                  initialValue: moduleName,
                  rules: [
                    {
                      required: true,
                      message: '请输入版块名称',
                    },
                  ],
                })}
              />
            </FormItem>
            {(activeModel === 1 ||
              activeModel === 10 ||
              (activeModel === 5 && selectedBlockIndex > 5) ||
              (activeModel === 51 && selectedBlockIndex > 7) ||
              (activeModel === 52 && selectedBlockIndex > 3) ||
              (activeModel === 6 && selectedBlockIndex > 4)) &&
              this.renderListItem(formItemLayout)}
            {((activeModel !== 1 &&
              activeModel !== 10 &&
              activeModel !== 5 &&
              activeModel !== 51 &&
              activeModel !== 52 &&
              activeModel !== 6) ||
              (activeModel === 5 && selectedBlockIndex < 6) ||
              (activeModel === 51 && selectedBlockIndex < 8) ||
              (activeModel === 52 && selectedBlockIndex < 4) ||
              (activeModel === 6 && selectedBlockIndex < 5)) && (
              <FormItem className="form-item-row" {...formItemLayout} label="版块类型">
                <Select
                  {...getFieldProps('moduleType', {
                    initialValue: moduleType,
                    rules: [
                      {
                        required: true,
                        message: '请选择版块栏目',
                      },
                    ],
                  })}
                >
                  <Option key={0} value={0}>
                    栏目
                  </Option>
                  <Option key={5} value={5}>
                    外链
                  </Option>
                </Select>
              </FormItem>
            )}
            {getFieldValue('moduleType') === 0 && this.renderColumn(formItemLayout)}
            {getFieldValue('moduleType') === 5 && (
              <FormItem className="form-item-row" {...formItemLayout} label="外链地址">
                <Input
                  {...getFieldProps('url', {
                    initialValue: url,
                    rules: [
                      {
                        required: true,
                        message: '请输入外链地址',
                      },
                    ],
                  })}
                />
              </FormItem>
            )}

            {this.renderFormList(activeModel, formItemLayout)}
          </Form>
        </Modal>
      </div>
    );
  }
}

export default SelectBlock;
